import { createAction, props } from '@ngrx/store';
import { ContactSuggesterItem } from '../../models/contact-suggester-item.model';
import { ListDetails } from '../../models/list-details.model';

function scoped(templateString: TemplateStringsArray) {
  return '[Emails Shared] ' + templateString[0];
}

export const addToNewEmail = createAction(
  scoped`Add To Email`,
  props<{
    contacts?: { prId?: number | null; crmId?: number | null }[];
    contactLists?: ListDetails[];
  }>()
);

export const composeNewEmail = createAction(scoped`Compose New Email`, props<{ recipients: ContactSuggesterItem[] }>());

export const clearRecipients = createAction(scoped`Clear Recipients`);
